import { Account } from "../../../api/dealer/DealerApi";
import { RBACRolesResponse } from "../../../api/rbac/types";
import { FeatureToggleDetail } from "../../../pages/featureToggles/types";

export enum ListRBACAccessActionKind {
  SET_USER_ROLE_DETAILS = "SET_USER_ROLE_DETAILS",
  SET_FEATURE_TOGGLE_DETAILS = "SET_FEATURE_TOGGLE_DETAILS",
  SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS",
  SET_DATA_LOADED = "SET_DATA_LOADED",
  UPDATE_PROCESSED_ACTION = "SET_UPDATE_PROCESSED_ACTION",
}

type SetUserRoleDetailsAction = {
  type: ListRBACAccessActionKind.SET_USER_ROLE_DETAILS;
  payload: PromiseSettledResult<RBACRolesResponse> | PromiseRejectedResult;
};

type SetFeatureToggleDetailsAction = {
  type: ListRBACAccessActionKind.SET_FEATURE_TOGGLE_DETAILS;
  payload: PromiseSettledResult<FeatureToggleDetail[]> | PromiseRejectedResult;
};

type SetAccountDetailsAction = {
  type: ListRBACAccessActionKind.SET_ACCOUNT_DETAILS;
  payload: PromiseSettledResult<{ data: Account[] }> | PromiseRejectedResult;
};

type SetDataLoadedAction = {
  type: ListRBACAccessActionKind.SET_DATA_LOADED;
  payload: boolean;
};

type UpdateProcessedAction = {
  type: ListRBACAccessActionKind.UPDATE_PROCESSED_ACTION;
  payload: {
    rbacEnabled: boolean;
    corporateViewEnabled: boolean;
    toggleProcessed: boolean;
    dataLoaded?: boolean;
  };
};

export type ListRBACAccessAction =
  | SetUserRoleDetailsAction
  | SetFeatureToggleDetailsAction
  | SetAccountDetailsAction
  | SetDataLoadedAction
  | UpdateProcessedAction;

export function setUserRoleDetailsAction(
  userRoleDetail:
    | PromiseSettledResult<RBACRolesResponse>
    | PromiseRejectedResult
): SetUserRoleDetailsAction {
  return {
    type: ListRBACAccessActionKind.SET_USER_ROLE_DETAILS,
    payload: userRoleDetail,
  };
}

export function setFeatureToggleDetailsAction(
  featureToggleDetail:
    | PromiseSettledResult<FeatureToggleDetail[]>
    | PromiseRejectedResult
): SetFeatureToggleDetailsAction {
  return {
    type: ListRBACAccessActionKind.SET_FEATURE_TOGGLE_DETAILS,
    payload: featureToggleDetail,
  };
}

export function setAccountDetailsAction(
  accountDetail:
    | PromiseSettledResult<{ data: Account[] }>
    | PromiseRejectedResult
): SetAccountDetailsAction {
  return {
    type: ListRBACAccessActionKind.SET_ACCOUNT_DETAILS,
    payload: accountDetail,
  };
}

export function setDataLoadedAction(dataLoaded: boolean): SetDataLoadedAction {
  return {
    type: ListRBACAccessActionKind.SET_DATA_LOADED,
    payload: dataLoaded,
  };
}

export function updateProcessedAction(
  rbacEnabled: boolean,
  corporateViewEnabled: boolean,
  toggleProcessed: boolean,
  dataLoaded?: boolean
): UpdateProcessedAction {
  return {
    type: ListRBACAccessActionKind.UPDATE_PROCESSED_ACTION,
    payload: { rbacEnabled, corporateViewEnabled, toggleProcessed, dataLoaded },
  };
}
